/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SupportStatus {
    TODO = 'TODO',
    IGNORED = 'IGNORED',
    IN_PROGRESS = 'IN_PROGRESS',
    DONE = 'DONE',
}
